import * as types from "./mutation-types";

import { IState } from "@/types/IState";
import { IRestoreTimer } from "@/types/IRestoreTimer";
import { INotificationStatus } from "@/types/INotificationStatus";
import { PomodoroStatus } from "@/enums/PomodoroStatus";

export default {
    [types.START_TIMER](state: IState, payload: { timerInterval: number }) {
        state.timerActive = true;
        state.timerInterval = payload.timerInterval;
    },

    [types.COUNTDOWN_TIMER](state: IState) {
        state.totalTime--;
    },

    [types.CHANGE_TIMER_STATUS](state: IState, payload: { workCount: number, totalTime: number, currentStatus: PomodoroStatus }) {
        state.workCount = payload.workCount;
        state.totalTime = payload.totalTime;
        state.currentStatus = payload.currentStatus;
    },

    [types.PAUSE_TIMER](state: IState) {
        state.timerActive = false;
        state.timerInterval = null;
    },

    [types.RESET_TIMER](state: IState) {
        state.workCount = 0;
        state.currentStatus = PomodoroStatus.WORK;
        state.timerActive = false;
        state.timerInterval = null;
        state.totalTime = state.workMinutes * 60;
        state.soundEnabled = false;
        state.vibrationEnabled = false;
    },

    [types.RESTORE_TIMER](state: IState, restore: IRestoreTimer) {
        state.totalTime = restore.totalTime;
        state.workCount = restore.workCount;
        state.currentStatus = restore.currentStatus;
        state.workMinutes = restore.workMinutes;
        state.shortBreakMinutes = restore.shortBreakMinutes;
        state.longBreakMinutes = restore.longBreakMinutes;
        state.soundEnabled = restore.soundEnabled;
        state.vibrationEnabled = restore.vibrationEnabled;
    },


    [types.CHANGE_NOTIFICATION_STATUS](state: IState, notification: INotificationStatus) {
        state.notificationEnabled = notification.notificationEnabled;
    },

    [types.CHANGE_WAKE_LOCK_STATUS](state: IState) {
        if (state.wakeLockEnabled) {
            state.noSleep.disable();
        } else {
            state.noSleep.enable();
        }
        state.wakeLockEnabled = !state.wakeLockEnabled;
    },

    [types.CHANGE_SOUND_STATUS](state: IState) {
        state.soundEnabled = !state.soundEnabled;
    },

    [types.CHANGE_VIBRATION_STATUS](state: IState) {
        state.vibrationEnabled = !state.vibrationEnabled;
    },

    [types.RESET_TIMER_SETTINGS](state: IState) {
        state.workMinutes = 25;
        state.shortBreakMinutes = 5;
        state.longBreakMinutes = 15;
        state.totalTime = 25 * 60;
    },

    [types.UPDATE_WORK_MINUTES](state: IState, payload: { workMinutes: number }) {
        state.workMinutes = payload.workMinutes;
    },

    [types.UPDATE_SHORT_BREAK_MINUTES](state: IState, payload: { shortBreakMinutes: number }) {
        state.shortBreakMinutes = payload.shortBreakMinutes;
    },

    [types.UPDATE_LONG_BREAK_MINUTES](state: IState, payload: { longBreakMinutes: number }) {
        state.longBreakMinutes = payload.longBreakMinutes;
    },

    [types.UPDATE_TOTAL_TIME](state: IState, payload: { totalTime: number }) {
        state.totalTime = payload.totalTime;
    },


    [types.PLAY_SOUND](state: IState) {
        if (state.soundEnabled) {
            state.sound.muted = false;
            state.sound.currentTime = 0;
            state.sound.play();
        }
    },

    [types.PREPARE_SOUND](state: IState) {
        state.sound.muted = true;
        state.sound.play();
    },

    [types.PLAY_VIBRATION](state: IState) {
        // android only
        if (state.vibrationEnabled && window.navigator.vibrate) {
            if (state.currentStatus === PomodoroStatus.WORK) {
                window.navigator.vibrate([
                    50,
                    100,
                    50,
                    100,
                    50,
                ]);
            } else {
                window.navigator.vibrate([
                    150,
                ]);
            }
        }
    },

    [types.UPDATE_WEBHOOK_METHOD](state: IState, payload: "POST" | "PUT" | null) {
        state.webhook.method = payload;
    },

    [types.UPDATE_WEBHOOK_URL](state: IState, payload: string | null) {
        state.webhook.url = payload;
    },

    [types.UPDATE_WEBHOOK_HEADERS](state: IState, payload: string | null) {
        state.webhook.headers = payload;
    },

    [types.UPDATE_WEBHOOK_DATA](state: IState, payload: string | null) {
        state.webhook.data = payload;
    },

    [types.RESET_WEBHOOK_SETTINGS](state: IState) {
        state.webhook.method = null;
        state.webhook.url = null;
        state.webhook.headers = null;
        state.webhook.data = null;
    },
};